var map = {
	"./checked.svg": 531117,
	"./fiber.svg": 802725,
	"./gift.svg": 177401,
	"./icon-info.svg": 254007,
	"./mobile.svg": 352846,
	"./tv.svg": 168993,
	"./tvMultiPlay.svg": 808814
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 223377;